// used for a grid that contains qty fields that update the price/total price fields

bq.productPrice = function(element, options) {
  this.options   = options;
  this.$element  = $(element);
  this.$form = false;
  this.basePrice = 0;
  this.finalPrice = 0;
  this.specialPrice = 0;
  this.maxPrecision = 0;
};

bq.productPrice.DEFAULTS = {
  form: false,
  basePrice: 0,
  finalPrice: 0,
  specialPrice: 0,
  baseUpdateClass: '.price',
  finalUpdateClass: '.price',
  specialUpdateClass: '.price',
  additionalBasePrices: false,
  additionalFinalPrices: false,
  specialPriceContainer: false
};

bq.productPrice.prototype = {
  init: function() {
    bq.debug.log("Product Price : init()", this.$element);


    if(!this.options.form) {
      bq.debug.error("Product Price : No data-form found", this);
      return;
    }

    this.$form = $(this.options.form);

    if(!this.$form.length) {
      bq.debug.error("Product Price : No valid form found", this);
      return;
    }

    this._setPrices();

    this.$form.parent().on('bq.productPrice.update', {thiz: this},  this.catchUpdateEvent);
    this.$form.on('change dp.change', {thiz: this},  this.catchChangeEvent);
  },

  getPricePrecision: function (price) {
    let separator = typeof accounting !== 'undefined' ? accounting.settings.number.decimal : '.';
    if (String(price).indexOf(separator) === -1) {
      return 2;
    }
    let precision =  String(price).substring(String(price).indexOf(separator) + 1).length;
    return (precision < 2) ? 2 : precision;
  },

  updatePrice: function() {
    if (this.options.basePrice  !== false) {
      $(this.options.baseUpdateClass, this.$element)
        .html(accounting.formatMoney(this.basePrice, null, this.maxPrecision));

      if (this.options.additionalBasePrices) {
        $(this.options.baseUpdateClass, $(this.options.additionalBasePrices))
          .html(accounting.formatMoney(this.basePrice, null, this.maxPrecision));
      }
    }

    if (this.options.specialPrice !== false && this.options.specialPriceContainer) {
      $(this.options.specialUpdateClass, $(this.options.specialPriceContainer))
          .html(accounting.formatMoney(this.specialPrice, null, this.maxPrecision));
    }

    if (this.options.finalPrice !== false) {
        $(this.options.finalUpdateClass, this.$element)
            .html(accounting.formatMoney(this.finalPrice, null, this.maxPrecision));

        if (this.options.additionalFinalPrices) {
            $(this.options.finalUpdateClass, $(this.options.additionalFinalPrices))
                .html(accounting.formatMoney(this.finalPrice, null, this.maxPrecision));
        }
    }
  },

  _setPrices: function() {
    if (this.options.basePrice !== false) {
      this.maxPrecision = this.getPricePrecision(this.options.basePrice);
      this.basePrice = this._getPrice(this.options.basePrice);
    }

    if (this.options.specialPrice !== false) {
      this.maxPrecision = this.getPricePrecision(this.options.specialPrice);
      this.specialPrice = this._getPrice(this.options.specialPrice);
    }

    if (this.options.finalPrice !== false) {
      this.maxPrecision = this.getPricePrecision(this.options.finalPrice);
      this.finalPrice = this._getPrice(this.options.finalPrice);
    }

    var $this = this;

    $('[data-price]', this.$form).each(function(){
      //first lets find out if its active
      var el = $(this);
      if(!($('#bundle').length > 0 && el.closest('.configure-option').length > 0)){
        var active = el[0].checked || el.is('option:selected')
            || (el.is('input[type="text"], textarea') && !/^\s*$/.test(el.val()));
        if (active) {
            var newPrice = $this._getPrice(el.data('price'));
            var newPricePrecision = $this.getPricePrecision(newPrice);
            if ($this.maxPrecision < newPricePrecision) {
              $this.maxPrecision = newPricePrecision;
            }
            $this.basePrice = accounting.formatNumber($this._getPrice($this.basePrice) + newPrice, $this.maxPrecision);
            $this.finalPrice = accounting.formatNumber($this._getPrice($this.finalPrice) + newPrice, $this.maxPrecision);
            $this.specialPrice = accounting.formatNumber($this._getPrice($this.specialPrice) + newPrice, $this.maxPrecision);
        }
      }
    });

    this.updatePrice();

  },

  _getPrice: function(price) {
    var newPrice = parseFloat(accounting.unformat(price));
    if(isNaN(newPrice) || newPrice < 0) { newPrice = 0; }
    //bq.debug.log('price: ', price, newPrice);
    return newPrice;
  },

  catchChangeEvent: function(e) {
    bq.debug.log("Product Price : event caught : change", e);
    var $this = e.data.thiz;
    $this._setPrices();
  },

  catchUpdateEvent: function(e, el) {
    bq.debug.log("Product Price : event caught : bq.productPrice.update", e);
    var $this = e.data.thiz;
    $this._setPrices();
  }

};

// LOAD BLOCK PLUGIN DEFINITION
// =======================

var productPriceold = $.fn.productPrice;

$.fn.productPrice = function (option, _relatedTarget) {
  return this.each(function () {
    var $this   = $(this);
    var data    = $this.data('bq.productPrice');
    var options = $.extend({}, bq.productPrice.DEFAULTS, $this.data(), typeof(option) === 'object' && option);

    if (!data) { $this.data('bq.productPrice', (data = new bq.productPrice(this, options))); }
    data.init();
  });
};

$.fn.productPrice.Constructor = bq.productPrice;

// LOAD BLOCK NO CONFLICT
// =================

$.fn.productPrice.noConflict = function () {
  $.fn.productPrice = productPriceold;
  return this;
};

// LOAD BLOCK DATA-API
// ==============

bq.productPriceInit = function() {
  $('[data-bq="product-price"]').each(function () {
    var el = $(this);
    if(el.data('bq.productPrice')) { return; }
    el.productPrice(el.data());
  });
};

bq.init.push(bq.productPriceInit);
